export const selectPreviousAccounts = (state) => state.previousAccounts;
const selectPreviousAccountsGroups = (state) => state.previousAccountsGroups;
export const selectPreviousAccountsGroupsData = (state) => selectPreviousAccountsGroups(state)?.data;
export const selectPreviousAccountsGroupsTotal = (state) => selectPreviousAccountsGroups(state)?.total;
export const selectPreviousAccountsInfo = (state) => state.previousAccountsInfo;
